import { dropStatus } from 'utils/drops';

const getPrecoFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatus,
    multiple: true,
    defaultValue: ['ATIVO'],
  },
  {
    name: 'produto',
    label: 'Produto',
    type: 'virtual-select',
    options: drops?.Produto,
    multiple: true,
    initial: true,
  },
  {
    name: 'linha',
    label: 'Linha',
    type: 'select',
    options: drops?.LinhaProduto,
    multiple: true,
  },
  {
    name: 'grupo',
    label: 'Grupo',
    type: 'select',
    options: drops?.GrupoProduto,
    multiple: true,
  },
  {
    name: 'cliente',
    label: 'Cliente',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    type: 'select',
    options: drops?.EntidadeTipo?.filter(
      (tipo) => tipo?.tipo === 'VENDEDOR' || tipo?.tipo === 'REPRESENTANTE'
    ),
    multiple: true,
  },
  {
    name: 'grupo_entidade',
    label: 'Grupo da Entidade',
    type: 'select',
    options: drops?.GrupoEntidade,
    multiple: true,
  },
  {
    name: 'condicao_pagamento',
    label: 'Condição de Pagamento',
    type: 'select',
    options: drops?.CondicaoPagamento,
    multiple: true,
  },
  {
    name: 'tabpreco',
    label: 'Tabela de Preço',
    type: 'select',
    options: drops?.TabelaPreco,
    multiple: true,
  },
  { name: 'preco', label: 'Preço', type: 'currency' },
  { name: 'margem', label: 'Margem', type: 'currency' },
];

export default getPrecoFilterFields;
